export default __webpack_public_path__ + "static/media/Group1268.19491295.png";